import React from 'react';
import PropTypes from 'prop-types';
import { SetupAccountStep1WelcomeLayout } from '../../layouts/SetupAccountStep1WelcomeLayout';

const SetupAccountStep1Welcome = ({ currentPage, onNextPage }) => {
    const Layout = SetupAccountStep1WelcomeLayout({ onNextPage });

    // Don't draw the component if it is not our page.
    if (currentPage !== 1) {
        return null;
    }

    return (
        <Layout />
    );
};

/* type checking for props */
SetupAccountStep1Welcome.propTypes = {
    currentPage: PropTypes.number.isRequired,
    onNextPage: PropTypes.func.isRequired,
};

export default SetupAccountStep1Welcome;
